import { Authentication } from "@hex-insights/app-modules";
import { Column, doNothing, Heading, If, Image, Paragraph, Row } from "@hex-insights/core";
import { Form, PasswordField, SubmissionStatus, SubmitButton, TextField } from "@hex-insights/forms";
import { InternalLink, useActivePageRegistration } from "@hex-insights/router";
import { Icon, serverRequest, StaticURLs } from "@hex-insights/verita-romania.shared";
import { Main } from "../../../Components";
import { AuthenticationContext } from "../../../Contexts";
import { recoverPageInfo } from "../Recover/pageinfo";
import { loginPageInfo } from "./pageinfo";
import styles from "../authentication.module.css";

export function LoginPage() {
	useActivePageRegistration(loginPageInfo);

	return (
		<Main className={styles["auth-page__main"]}>
			<Column
				justify="spaced-center"
				align="center"
				verticalSpacing="1.5rem"
				className={styles["auth-page__content-container"]}
			>
				<Image src={StaticURLs.Images.veritaWingsSymmetricSmall} />

				<Heading.H1 noMargin>Verita Portal</Heading.H1>

				<div style={{ maxWidth: "100%" }}>
					<LoginForm onSuccess={doNothing} />
				</div>
			</Column>
		</Main>
	);
}

type LoginFormProps = {
	onSuccess: () => void;
};

function LoginForm({ onSuccess }: LoginFormProps) {
	const { formState, onSubmit, linkState } = Authentication.useLogin({
		AuthenticationContext,
		requestLogin,
		onSuccess,
	});

	return (
		<Form formState={formState} onSubmit={formState.onSubmitWrapper(onSubmit)} noNotifications noNavigationPrompt>
			<Column justify="spaced-start">
				<If condition={SubmissionStatus.isFailure(formState.submissionStatus)}>
					<Row
						justify="spaced-start"
						style={{
							backgroundColor: "var(--theme-colors__pink--background)",
							padding: "0.5rem 0.75rem",
							borderRadius: "0.5rem",
							minWidth: 0,
						}}
					>
						<Icon.WarningOctagon color="var(--theme-colors__pink)" size={20} />

						<Paragraph>{formState.formSubmissionErrors._.join(" ")}</Paragraph>
					</Row>
				</If>

				<TextField formState={formState} name="email" autoFocus inputMode="email" style={{ maxWidth: "100%" }} />
				<PasswordField formState={formState} name="password" allowVisibility style={{ maxWidth: "100%" }} />

				<Column justify="spaced-start" verticalSpacing="1.5rem">
					<Row justify="flex-end">
						<InternalLink
							to={{ pathname: recoverPageInfo.to, state: linkState }}
							className="link--primary link--no-text-decoration"
							style={{ fontWeight: "bold" }}
						>
							Forgot Password?
						</InternalLink>
					</Row>

					<SubmitButton
						submissionStatus={formState.submissionStatus}
						onClick={formState.onSubmitWrapper(onSubmit)}
						style={{ width: "100%", fontSize: "1rem", fontWeight: "bold" }}
					>
						Login
					</SubmitButton>
				</Column>
			</Column>
		</Form>
	);
}

function requestLogin(formValues: Authentication.LoginFormValues) {
	return serverRequest("/auth/login", {
		method: "POST",
		body: JSON.stringify(formValues),
	});
}
